import { defineMessages } from 'react-intl';

export default defineMessages({
  statement: {
    id: 'component.FDAStatement.statement',
    defaultMessage:
      'The products and information presented on this website have not been evaluated by the Food and Drug Administration. The products on this website are not intended to diagnose, treat, cure or prevent any disease or illness. All information presented on this website is not meant as a substitute for or alternative to information from health care practitioners. Please consult your health care professional about potential interactions or other possible complications before using any product.',
  },
});
